import React from 'react';
import { Route, Routes, Navigate } from "react-router-dom";
import AdminDashboard from '../components/admin/AdminDashboard';
import MembersPage from '../components/admin/Members';
import MeetingsPage from '../components/admin/Meetings';
import LogsPage from '../components/admin/LOgsPage';
import Login from '../components/Login';

function AdminRoute() {
  return (
    <Routes>
      <Route path='/admin' element={<AdminDashboard />} />
      <Route path='/admin/*' element={<AdminDashboard />} />
      <Route path='/admin/members' element={<MembersPage />} />
      <Route path='/admin/meetings' element={<MeetingsPage />} />
      <Route path='/admin/logs' element={<LogsPage />} />
        <Route path='/login' element={<Login />} />
      {/* Add more admin routes here as you create them */}
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}

export default AdminRoute;